import React,{useEffect,useState,useCallback} from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../utils/getTranslation';
import './styles.scss';
import { useDispatch, useSelector } from "react-redux"
import { Container, Row, Col, Form, Button,Modal,CloseButton } from "react-bootstrap"
import { PsyItem, StripeCard } from "../../components";
import { Link, useHistory } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel'
import Slider from "react-slick";
import { getBest , getPage} from "../../actions/mixedmode";
import { BASE_URL_PROD } from "../../components/config/keys";
import { defaultimg } from "../../assets/images";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useParams } from "react-router";
import {IS_SUBMITED,SET_FORMULE,SET_FORMULE_UPDATE} from "../../constants/actions"
import { apiClient } from "../../actions/api"
import { fetchAbonnement } from "../../actions/api_interface"
import moment from 'moment'

import{useGoCardlessDropin, GoCardlessDropinOptions, GoCardlessDropinOnSuccess} from '@gocardless/react-dropin';
import StripePaymentElement from '../../components/payment/StripePaymentElement';
import { loadStripe } from '@stripe/stripe-js';

const Page = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const queryParams = new URLSearchParams(window.location.search);
    const isupdatetherapeut = queryParams.get('p');

    const [value, setValue] = useState(0);

    const [show,setShow]=useState(false);
    const { data,pageinfo } = useSelector(state => state.mixedmode);
    const { user,formule,formuleupdate } = useSelector(state => state.user);
    const { issubmited } = useSelector(state => state.global)

    const { keyword:gottenKeyword } = useParams();
    const [keyword, setkeyword] = useState(gottenKeyword)
    const [therapeute,setTherapeut]=useState([{}]);
    const [curentFormule,setcurentFormule]=useState({});
    const [readplus,setReadPlus]=useState(0);
    const [isError, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showChangeCard, setShowChangeCard] = useState(false);
    const [showpaiement, setshowpaiement] = useState(false);
    const [ErrorUser,setErrorUser]=useState(false);
    const [IDFOLOW,setIDFOLOW]=useState('');
    const [IDMANDAT,setIDMANDAT]=useState('');
    const [hasabonoed,sethasabonoed]=useState(false);

    const [loading,       setloading]       = useState(false);
    const [isabonement,   setisabonement]   = useState(false);
    const [isNotReferent, setIsNotReferent] = useState(false);
    const [currentReferent, setCurrentReferent] = useState(false);
    const [reservation,   setreservation]   = useState(false);
    const [okpaiement,    setokpaiement]    = useState(false);

    // États pour le système de codes de réduction
    const [currentDiscount, setCurrentDiscount] = useState(null);

    const [stripeClientSecret, setStripeClientSecret] = useState(null);
    const [isMigration,        setIsMigration]        = useState(false);
    const [alreadyMigrated,    setAlreadyMigrated]    = useState(false);
    const [needsStripeMigration, setNeedsStripeMigration] = useState(false);
    const [paymentMethodDetails, setPaymentMethodDetails] = useState(null);
    const [initialized, setInitialized] = useState(false);
    const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

    const handleClose = () => setShow(false);

    const currentlangStorage = localStorage.getItem("currentlang");

    const [langset, setLangset] = useState(false);
    const [tab, setTab] = useState(1);
    const [tabins, setTabins] = useState(1);
    const [active,setActive]=useState(2);
    const [active2,setActive2]=useState(1);
    const [active3,setActive3]=useState(1);
    const [iflivreur,setIflivreur]=useState(false);
    const [avgnote,setavgnote]=useState(0);

    // Récupérer le code de réduction actuel
    function getCurrentDiscountCode() {
        apiClient().get('/discount-codes/current', { 
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
        .then((res) => {
            if (res.data.success === 'ok') {
                if (res.data.data.has_code) {
                    setCurrentDiscount(res.data.data.data);
                }
            }
        })
        .catch((error) => {
            console.log('Erreur lors de la récupération du code actuel:', error);
        });
    }

    // Fonction pour calculer le prix avec réduction (POUR AFFICHAGE UNIQUEMENT)
    const calculateDiscountedPrice = (originalPrice, discountData) => {
        if (!discountData || !discountData.is_valid) {
            return {
                original: originalPrice,
                discounted: originalPrice,
                hasDiscount: false,
                savings: 0,
                percentage: 0
            };
        }

        const percentage = discountData.reduction_percentage;
        const savings = originalPrice * (percentage / 100);
        const discountedPrice = originalPrice - savings;

        return {
            original: originalPrice,
            discounted: discountedPrice,
            hasDiscount: true,
            savings: savings,
            percentage: percentage
        };
    };

    // Obtenir le prix à AFFICHER (avec réduction pour l'UI)
    const getDisplayPrice = () => {
        const originalPrice = parseFloat(curentFormule?.price);
        const priceDetails = calculateDiscountedPrice(originalPrice, currentDiscount);
        return priceDetails.discounted.toFixed(2);
    };

    // IMPORTANT: Obtenir le prix ORIGINAL à envoyer au backend
    // Le backend calculera lui-même la réduction
    const getOriginalPrice = () => {
        return parseFloat(curentFormule?.price).toFixed(2);
    };

    const QuickFixButtonWithCondition = () => {
      if (isNotReferent) {
        return null
      }

      return (
        <Button
          className="ps-btn ps-btn--fullwidth ps-btn-dark ommp00" type="button" disabled>
          {t('payment.pay_button', { amount: getDisplayPrice() })}
        </Button>
      )
    }

    useEffect(() => {
      if (currentReferent && therapeute && currentReferent.user_id !== therapeute.user_id) {
        setIsNotReferent(true)
      }
    }, [currentReferent, therapeute])

    useEffect(() => {
      fetchAbonnement(user, (abonnement) => {
        setCurrentReferent(abonnement.referent)
      })
    }, [])

    useEffect(()=>{
      if(!user?.adresse || !user?.codepostal|| !user?.city  ){
        history.push('/profile/?redirect=1')
      }

      getuser()
      
      // Récupérer le code de réduction si l'utilisateur est connecté
      if(user?.api_token) {
        getCurrentDiscountCode();
      }

      if(!user?.user_id){
           history.push('/');
      }
      if (user?.active===0) {
            history.push('/infos-patient');
      }

       handlerVerification()

       if(isupdatetherapeut==='true'){
          setcurentFormule(formuleupdate?.formule)
          setTherapeut(formuleupdate?.therapeut)
       }
       else{
         setcurentFormule(formule?.formule)
          setTherapeut(formule?.therapeut)
       }

       dispatch(getPage(56))

       let sum=0;
           for (var i = 0; i < formule?.therapeut?.avg.length; i++) {
                sum=sum+parseInt(formule?.therapeut?.avg[i].note)
           }
          if(sum>0){
            setavgnote(sum/formule?.therapeut?.avg.length)
      }
    },[user])

    function getuser(){
       let params={
              token:user.api_token,
              api_token:user.api_token,
          }

          apiClient().post(`/get/user`,params )
           .then((res) => {
              if(res.data.success=='ok'){
                  if(res.data.user?.adolescent===1){
                     setErrorUser(true)
                     setshowpaiement(false)
                  }
                  else{
                    setErrorUser(false)
                    setshowpaiement(true)
                  }
              }
              else{
                setError(true)
              }
           })
    }

     const handleClick = (slug) => {
        history.push(slug);
    }

   const handleShow = (item) => {
      setShow(true);
    }

   const handleGoTo = (slug) => {
         history.push(slug)
    }

  const handleTabs=(a)=>{
             setActive(a)
    }

    const handleTabs2=(a)=>{
             setActive2(a)
             if(a==2){
               history.push("/devenir-vendeur/")
             }
    }
    
    const handleTabs3=(a)=>{
             setActive3(a)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target)
        const formDataObj = Object.fromEntries(formData.entries())
        history.push('/paiement')
    }

    const handlersavepaiement = async (e) =>{
         e.preventDefault();
         const formData = new FormData(e.target)
         const formDataObj = Object.fromEntries(formData.entries())
    }

    const handlerVerification =  () => {
       let params={
              token:user.api_token,
              api_token:user.api_token,
          }

         apiClient().post(`/get/dossierpatient`, params)
           .then((res) => {
              if (res.data.success === 'ok') {
                 if(res.data.count<=0){
                     localStorage.setItem('dossierisokreturn', true);
                     history.push('/dossier-patient')
                 }
                 else{
                    localStorage.setItem('dossierisokreturn', false);
                 }
              }
           })
    }

    const handlersaveorder =  (billingobj,id_paiement,d,curency='',abonnement_id=null,overrideParams=null) => {
          setError(false)
          setloading(true)

          // IMPORTANT : Envoyer le prix ORIGINAL au backend
          // Le backend calculera la réduction lui-même depuis $user->discount_code_id
          const originalPrice = getOriginalPrice();

          const therapeut_id = overrideParams?.therapeut_id ?? therapeute?.user_id
          const tarif_id     = overrideParams?.tarif_id     ?? (isupdatetherapeut==='true' ? formuleupdate?.tarif?.id : formule?.tarif?.id)
          const formule_id   = overrideParams?.formule_id   ?? (isupdatetherapeut==='true' ? formuleupdate?.formule?.id : formule?.formule?.id)
          const date_rdv     = overrideParams?.date_rdv     ?? (isupdatetherapeut==='true' ? formuleupdate?.date : formule?.date)
          const heure_rdv    = overrideParams?.heure_rdv    ?? (isupdatetherapeut==='true' ? formuleupdate?.heure : formule?.heure)

          let params={
              patient_id:user?.user_id,
              therapeut_id,
              tarif_id,
              formule_id,
              date_rdv,
              heure_rdv,
              idflow:IDFOLOW,
              mandat:d==true ? billingobj?.links?.mandate_request_mandate : IDMANDAT,
              id_paiement:id_paiement,
              total_price:originalPrice, // Prix ORIGINAL, le backend appliquera la réduction
              token:user.api_token,
              api_token:user.api_token,
              curency:curency,
              isupdate:isupdatetherapeut==='true' ? true : false,
              ...(abonnement_id && { abonnement_id })
          }

          apiClient().post(`/save/reservation`,params )
           .then((res) => {
              if(res.data.success=='ok'){
                  setloading(false)
                  dispatch({ type: SET_FORMULE, payload: {} })
                  history.push('/paiement-valide/')
              } else if (res.data.requires_action && res.data.client_secret) {
                  handle3DSAction(res.data.client_secret, res.data.reservation_id)
              } else {
                setError(true)
                setloading(false)
              }
           })
           .catch((err) => {
               setloading(false)
               setStripeClientSecret(null)
               setNeedsStripeMigration(false)
               setErrorMessage(err?.response?.status === 402
                   ? (t('payment.card_declined') || 'Votre paiement a échoué.')
                   : (t('payment.error_generic') || 'Une erreur est survenue.')
               )
               setShowChangeCard(true)
           })
    }

    const handle3DSAction = async (clientSecret, reservationId) => {
        try {
            const stripeInstance = await loadStripe(stripePublishableKey)
            const { error, paymentIntent } = await stripeInstance.handleNextAction({ clientSecret })
            if (error) {
                setError(true)
                setloading(false)
            } else if (paymentIntent && paymentIntent.status === 'succeeded') {
                dispatch({ type: SET_FORMULE, payload: {} })
                history.push('/paiement-valide/')
            }
        } catch (err) {
            setError(true)
            setloading(false)
        }
    }

    const getfolowid = () => {
      let params={
        token:user.api_token,
        api_token:user.api_token,
        user_id:user?.user_id
      }

      apiClient().post(`/init-paiement`, params)
      .then((res) => {
        if(res.data.success == true){
           if(res.data.isabonement){
              setisabonement(true)
              setreservation(res.data.reservation)
              if(res.data.needs_stripe_migration){
                  setNeedsStripeMigration(true)
                  getmandatid()
              }
           }
           else{
              // ── Stripe ───────────────────────────────────────────
              if(res.data.stripe_client_secret){
                setStripeClientSecret(res.data.stripe_client_secret)
                return
              }
              // ── GoCardless (legacy) ───────────────────────────────
              if(res.data.folow_id == ''){
                setIDMANDAT(res.data.id_mandat)
              }
              else{
                setIDFOLOW(res.data.folow_id)
              }
           }
        }
        else{
          setError(true)
        }
        setInitialized(true)
      })
    }

    const getmandatid = (forceNew = false) => {
     let params={
              token:user.api_token,
              api_token:user.api_token,
              user_id:user?.user_id,
              force_new_setup: forceNew
          }

          apiClient().post(`/get-mandat`,params )
           .then((res) => {
              if(res.data.success==true){
                 // ── Stripe ───────────────────────────────────────────
                 if(res.data.already_migrated){
                   setAlreadyMigrated(true)
                   if (res.data.payment_method) {
                       setPaymentMethodDetails(res.data.payment_method)
                   }
                   return
                 }
                 if(res.data.stripe_client_secret){
                   setStripeClientSecret(res.data.stripe_client_secret)
                   setIsMigration(res.data.is_gocardless_migration === true)
                   return
                 }
                 // ── GoCardless (legacy) ───────────────────────────────
                 if(res.data.isabonement){
                    setisabonement(true)
                 }
                 else{
                    if(res.data.id_mandat!==''){
                        setIDMANDAT(res.data.id_mandat)
                    }
                 }
              }
              else{
                setError(true)
              }
           })
    }
    
    useEffect(() => {
        if(langset == false){
           if(isupdatetherapeut === 'true'){
             getmandatid()
           }
           else{
             getfolowid()
           }
            setLangset(true)
        }
    }, [])

    const handleChangecheckbox = event => {
      if (event.target.checked) {
         setokpaiement(true)
      } else {
       setokpaiement(false)
      }
    };

    const paydirect = (e) => {
        setloading(true)
        
        // IMPORTANT : Envoyer le prix ORIGINAL
        // Le backend calculera la réduction lui-même depuis $user->discount_code_id
        const originalPrice = getOriginalPrice();
        
        let params={
              token:user.api_token,
              api_token:user.api_token,
              mandat_id:IDMANDAT,
              amount:originalPrice // Prix ORIGINAL
          };

          apiClient().post(`/save-transaction`,params )
           .then((res) => {
              if(res.data.success == true){
                handlersaveorder('',res.data.id_paiement,false)
              }
              else{
                setError(true)
                setloading(false)
              }
           })
    };

    const handleStripeSuccess = ({ paymentMethodId, paymentMethodType }) => {
        setError(false)
        setloading(true)
        const params = {
            token:               user.api_token,
            api_token:           user.api_token,
            payment_method_id:   paymentMethodId,
            payment_method_type: paymentMethodType,
            tarif_id:            isupdatetherapeut === 'true' ? formuleupdate?.tarif?.id : formule?.tarif?.id,
            formule_id:          isupdatetherapeut === 'true' ? formuleupdate?.formule?.id : formule?.formule?.id,
            amount:              getOriginalPrice(),
            currency:            'EUR',
        }
        apiClient().post('/save-transaction', params)
            .then((res) => {
                if (res.data.success === true) {
                    if (needsStripeMigration && reservation) {
                        handlersaveorder(
                            '',
                            res.data.id_paiement,
                            false,
                            'EUR',
                            res.data.abonnement_id,
                            {
                                therapeut_id: reservation.therapeut_id,
                                tarif_id:     reservation.tarif_id,
                                formule_id:   reservation.formule_id,
                                date_rdv:     reservation.date_rdv,
                                heure_rdv:    reservation.heure_rdv,
                            }
                        )
                    } else {
                        handlersaveorder('', res.data.id_paiement, false, 'EUR', res.data.abonnement_id)
                    }
                } else {
                    setError(true)
                    setloading(false)
                }
            })
            .catch(() => {
                setError(true)
                setloading(false)
            })
    }

    const handler = useGoCardlessDropin({
        billingRequestFlowID: IDFOLOW,
        environment: "live",
        onSuccess: (billingRequest, billingRequestFlow) => {
          console.log('billingRequest.links:', JSON.stringify(billingRequest?.links, null, 2));

           setloading(true)
           
           // IMPORTANT : Envoyer le prix ORIGINAL
           // Le backend calculera la réduction lui-même depuis $user->discount_code_id
           const originalPrice = getOriginalPrice();
           
           let params={
              token:user.api_token,
              api_token:user.api_token,
              mandat_id:billingRequest?.links?.mandate_request_mandate,
              customer_id: billingRequest?.links?.customer,
              amount:originalPrice, // Prix ORIGINAL
              currency:billingRequest?.mandate_request?.currency
          };

          apiClient().post(`/save-transaction`,params )
           .then((res) => {
              if(res.data.success==true){
                   handlersaveorder(billingRequest,res.data.id_paiement,true,billingRequest?.mandate_request?.currency)
              }
              else{
                setError(true)
                setloading(false)
              }
           })
        },
        onExit: (error, metadata) => {
        },
    });

    // Composant pour afficher le prix avec ou sans réduction
    const PriceDisplay = () => {
        if (!curentFormule?.price) return null;
        
        const originalPrice = parseFloat(curentFormule.price);
        const priceDetails = calculateDiscountedPrice(originalPrice, currentDiscount);
        
        if (priceDetails.hasDiscount) {
            return (
                <div className="price-with-discount">
                    <h4 className="original-price">
                        <span style={{textDecoration: 'line-through', color: '#FF914D', fontSize: '0.8em'}}>
                            {priceDetails.original.toFixed(2)}€
                        </span>
                    </h4>
                    <h4 className="discounted-price" style={{color: '#43c3cc'}}>
                        {priceDetails.discounted.toFixed(2)}€<span><sup>/séance</sup></span>
                    </h4>
                    <div style={{textAlign: 'center', marginTop: '8px'}}>
                        <div className="savings-badge" style={{
                            background: '#28a745', 
                            color: 'white', 
                            padding: '4px 8px', 
                            borderRadius: '4px', 
                            fontSize: '0.75em',
                            display: 'inline-block'
                        }}>
                            -{priceDetails.percentage}% • Économie: {priceDetails.savings.toFixed(2)}€
                        </div>
                    </div>
                </div>
            );
        }
        
        return <h4>{priceDetails.original.toFixed(2)}€<span><sup>/séance</sup></span></h4>;
    };

    const returnformpaiement = () => {
    return(
                    <Row>
                    <Col lg={{ span: 12 }} className="text-center mx-auto " >

                        {/* Affichage du code de réduction actif */}
                        {currentDiscount && (
                            <div className="alert alert-success discount-alert-paiement" style={{
                                background: 'linear-gradient(90deg, #43c3cc 0%, #4fc5cd 35%, #6feaf2 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '15px',
                                marginBottom: '20px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
                                    <i className="fa fa-percent" style={{fontSize: '1.3em'}}></i>
                                    <div>
                                        <strong style={{display: 'block'}}>Code {currentDiscount.code} appliqué</strong>
                                        <small>Réduction de {currentDiscount.reduction_formattee}</small>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className='center'>
                              <img className='ommp00'  src='/images/004888i12b.png' />
                        </div>

                        <div className='center '><img className='ommp01' src='/images/visa-mastercard-icon-5.png' /></div>
                           <br/>

                          <h5 style={{color:'#000', textAlign:'center'}}>{t('payment.card_payment')}</h5>

                           <div className="mb-5">

                        <div style={{marginTop:'20px'}}></div>

                        <Form.Group className="mb-3" >
                               <br/>

                        {
                          alreadyMigrated ? (
                            loading ? (
                                <div style={{display:'flex', justifyContent:'center', alignItems:'center', padding:'40px 0'}}>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Chargement...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {paymentMethodDetails && (
                                        <div style={{display:'flex', justifyContent:'center', margin:'16px 0'}}>
                                            <StripeCard {...paymentMethodDetails} />
                                        </div>
                                    )}
                                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'12px', marginTop:'16px'}}>
                                        <button
                                            type="button"
                                            className="btn btn-outline-dark btn-sm"
                                            style={{color:'#212529'}}
                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor='#212529'; e.currentTarget.style.color='#fff'; }}
                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor='transparent'; e.currentTarget.style.color='#212529'; }}
                                            onClick={() => {
                                                setAlreadyMigrated(false)
                                                setPaymentMethodDetails(null)
                                                getmandatid(true)
                                            }}
                                        >
                                            {t('payment.change_card') || 'Changer de carte'}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => handlersaveorder('', null, false, 'EUR', null)}
                                        >
                                            {(t('payment.pay_now') || 'Payer') + ' — ' + getOriginalPrice() + ' €'}
                                        </button>
                                    </div>
                                </>
                            )
                          ) : stripeClientSecret ? (
                            <div style={{marginTop:'20px'}}>
                              <StripePaymentElement
                                clientSecret={stripeClientSecret}
                                stripePublishableKey={stripePublishableKey}
                                onSuccess={handleStripeSuccess}
                                onError={() => { setError(true) }}
                                migrationMessage={isMigration ? t('payment.stripe_migration_message') : null}
                                buttonLabel={t('payment.stripe_pay_title')}
                              />
                            </div>
                          ) : (IDFOLOW || IDMANDAT) ? (
                            <div>
                              {
                                !loading ?

                                  <div>

                                    {
                                      !isNotReferent &&
                                      <div className='js889' style={{    marginBottom: '14px'}}>
                                        <input type='checkbox' name='adolesant' value='1' onChange={handleChangecheckbox} />
                                        <span style={{paddingLeft: '8px'}}>{t('appointment.accept_videocall')}</span>
                                      </div>
                                    }

                                    {
                                      okpaiement ?
                                      <div>
                                        {
                                          IDFOLOW && !isNotReferent &&
                                             <Button
                                              className="ps-btn ps-btn--fullwidth ps-btn-dark ommp00" type="button" onClick={()=>handler.open()}>
                                              {t('payment.pay_button', { amount: getDisplayPrice() })}
                                             </Button>
                                        }

                                       {
                                          IDMANDAT && !isNotReferent &&
                                             <Button
                                              className="ps-btn ps-btn--fullwidth ps-btn-dark ommp00" type="button" onClick={(e)=>paydirect(e)}>
                                              {t('payment.pay_button', { amount: getDisplayPrice() })}
                                             </Button>
                                        }
                                      </div>
                                     :
                                      <QuickFixButtonWithCondition />
                                    }
                                 </div>
                                   :
                                   <div className='alert alert-warning'>
                                      <p>{t('payment.processing')}</p>
                                      <div className='center'>
                                         <img src='/images/157446935584697.gif' style={{width:'90px'}} />
                                      </div>
                                   </div>
                              }
                            </div>
                          ) : null
                        }

                         </Form.Group>

                           {
                            isError &&
                            <div className="alert alert-danger" style={{marginTop:'40px'}}>
                               {t('common.error_retry_later')}
                            </div>
                           }

                           {errorMessage && (
                               <div className="alert alert-danger mt-3">
                                   <p style={{margin:0}}>{errorMessage}</p>
                                   {paymentMethodDetails && (
                                       <div style={{display:'flex', justifyContent:'center', margin:'16px 0'}}>
                                           <StripeCard {...paymentMethodDetails} />
                                       </div>
                                   )}
                                   {showChangeCard && (
                                       <button
                                           type="button"
                                           className="btn btn-outline-light btn-sm mt-2"
                                           onClick={() => {
                                               setErrorMessage('')
                                               setShowChangeCard(false)
                                               setAlreadyMigrated(false)
                                               getmandatid(true)
                                           }}
                                       >
                                           {t('payment.change_card') || 'Changer de carte'}
                                       </button>
                                   )}
                               </div>
                           )}

                           {isabonement && !needsStripeMigration && (
                            <>
                              <div className="alert alert-danger" style={{marginTop:'40px'}}>
                                  {t('subscription.already_subscribed', { formula: getTranslation(reservation?.formule?.titre, i18n.language), price: getTranslation(reservation?.tarif?.titre, i18n.language) })}
                              </div>
                              {reservation && (
                                <button
                                    type="button"
                                    className="btn btn-primary mt-3"
                                    onClick={() => handlersaveorder(
                                        '',
                                        null,
                                        false,
                                        'EUR',
                                        reservation.abonnement_id,
                                        {
                                            therapeut_id: reservation.therapeut_id,
                                            tarif_id:     reservation.tarif_id,
                                            formule_id:   reservation.formule_id,
                                            date_rdv:     reservation.date_rdv,
                                            heure_rdv:    reservation.heure_rdv,
                                        }
                                    )}
                                >
                                    {t('payment.pay_now') || 'Payer'}
                                </button>
                              )}
                            </>
                           )}

                           {
                            needsStripeMigration && stripeClientSecret && (
                              <div style={{marginTop:'20px'}}>
                                <StripePaymentElement
                                  clientSecret={stripeClientSecret}
                                  stripePublishableKey={stripePublishableKey}
                                  onSuccess={handleStripeSuccess}
                                  onError={() => { setError(true) }}
                                  migrationMessage={t('payment.stripe_migration_message')}
                                  buttonLabel={t('payment.stripe_pay_title')}
                                />
                              </div>
                            )
                           }

                           {
                            isNotReferent &&
                            <div className="alert alert-danger" style={{marginTop:'40px'}}>
                              {t('appointment.not_your_referent')}
                            </div>
                           }

                        </div>

                        {
                          !isabonement &&
                           <p className='alert alert-success' dangerouslySetInnerHTML={{ __html: getTranslation(pageinfo?.contenu, i18n.language)}} ></p>
                        }

                    </Col>
                </Row>
      )
    }

    const returnErrorAdolescent = () => {
         return (
            <div className='alert alert-danger' style={{    display: 'flex',alignItems: 'center'}}><span style={{fontSize: '24px',marginRight: '10px'}}><i className='fa fa-remove'></i></span>{t('auth.account_verifying')}</div>
        )
    }

    useEffect(() => {
        if (!initialized) return
        const formuleVide = !formule?.tarif?.id && !formule?.date && !formule?.heure
        const hasStripeContext = alreadyMigrated || needsStripeMigration || isabonement

        if (formuleVide && !hasStripeContext) {
            dispatch({ type: SET_FORMULE, payload: {} })
            history.replace('/nos-praticiens')
        }
    }, [initialized, formule, alreadyMigrated, needsStripeMigration, isabonement])

    return (
        <div className="home paiementtherapeut" >

          <section>
          <div className="ps-breadcrumb"><div className="container"><div className="ps-container"><ul className="breadcrumb"><li><a href="#" onClick={()=>history.push(`/`)}>{t('nav.home')}</a></li><li>{t('common.col_therapist')}</li><li>{t('appointment.step_payment')}</li></ul></div></div></div>
          </section>

 <section className="section2  " style={{paddingTop:'10px'}} >
    <div className="holder">
    <ul className="SteppedProgress">
    <li className="boxed  complete   ">{t('appointment.step_choose_therapist')}</li>
    <li className="boxed  complete  ">{t('appointment.step_patient_info')}</li>
    <li className="boxed complete ">{t('appointment.step_payment')}</li>
    <li className="boxed  ">{t('appointment.step_done')}</li>
    </ul>
    </div>
 </section>

          <section className="section2 thisprofil listtherapeutes " >
                <Container>

                  <div className='row'>

                     <Col md={6} >

                     <div className='therapeutescontent'>

        <div style={{display:'block',paddingTop:'0px'}} >

           {
             showpaiement &&
            returnformpaiement()
           }

           {
             ErrorUser &&
            returnErrorAdolescent()
           }

        </div>

               </div>

                     </Col>

                     <Col md={1} >
                     </Col>

                     <Col md={5} >

                  <div className='therapeutescontent'>

                      <Row className=''>
                        <Col md={12} >
                             <div className='flexitems row'>
                                 <div className='itemimg col-md-3' style={{backgroundImage:therapeute?.picture ? `url(${BASE_URL_PROD + "gestion/public/uploads/"+therapeute?.picture})` : "url('/images/default-profile.png')"}}>
                                 </div>
                                  <div className='itemheader col-md-8' >
                                    <h3>{therapeute?.first_name} {therapeute?.last_name} </h3>

                                 <div className="ps-product--detail ">
                                  <div className="ps-product__meta">
                                    <div className="ps-product__rating" >
                                        <div className="br-wrapper br-theme-fontawesome-stars">
                                        </div>
                                    </div>
                                </div>
                                </div>

                                  <div className=''>

                                  {
                                    isupdatetherapeut==='true' ?
                                    <div>
                                         <div className='item' style={{paddingBottom:'10px'}}>{t('common.date_label_value', { date: moment.utc(formuleupdate?.fullDate).local().format("DD/MM/YYYY") })}</div>
                                         <div className='item' style={{paddingBottom:'10px'}}>{t('common.time_label_value', { time: moment.utc(formuleupdate?.fullDate).local().format("HH:mm") })}</div>
                                         <div className='item' style={{paddingBottom:'10px'}}>{t('appointment.your_formula_value', { formula: getTranslation(formuleupdate?.formule?.titre, i18n.language) })}</div>
                                     </div>
                                    :
                                    <div>
                                         <div className='item' style={{paddingBottom:'10px'}}>{t('common.date_label_value', { date: moment.utc(formule?.fullDate).local().format("DD/MM/YYYY") })}</div>
                                         <div className='item' style={{paddingBottom:'10px'}}>{t('common.time_label_value', { time: moment.utc(formule?.fullDate).local().format("HH:mm") })}</div>
                                         <div className='item' style={{paddingBottom:'10px'}}>{t('appointment.your_formula_value', { formula: getTranslation(formule?.formule?.titre, i18n.language) })}</div>
                                      </div>
                                  }

                                  </div>

                                 </div>
                             </div>

                        </Col>
                        <Col md={3} >
                           <div className='actionrdv'>
                               <div className="text-center" >
                                </div>
                           </div>
                        </Col>
                       </Row>

                    </div>

                <div className='therapeutescontent'>

                    <div className='flexrowtarifs row'>

                      <div className='item'>

                  <div className='pricebox' style={{boxShadow: 'none'}}>
                  <h3>{getTranslation(curentFormule?.titre, i18n.language)}</h3>
                  
                  {/* Utilisation du composant PriceDisplay */}
                  <PriceDisplay />
                  
                   <div className="pricebox-border2"> </div>
                  <div className='ttcontent'>
                  <ul className='col-9028-K'>
                       <li><i className='fa fa-check-circle icochecked'></i> {curentFormule?.temps} min</li>
                  </ul>

                  <label>
                     Description
                  </label>
                  <p>{ curentFormule?.id==readplus ?  getTranslation(curentFormule?.contenu, i18n.language) : curentFormule?.shotconte}  <br/> { (curentFormule?.id!==readplus && curentFormule?.show==1) && <a href='javascript:void(0)' onClick={()=>setReadPlus(curentFormule?.id)}>{t('common.read_more')}</a> } </p>

                  </div>
               </div>

                      </div>

                    </div>
                </div>

                     </Col>

                  </div>

                </Container>
          </section>

      <Modal show={show} onHide={handleClose} className='modelhermixtarif'   size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
        <Modal.Header   >
          <CloseButton variant="dark" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
        </div>
    );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default Page;